import './components/mjml/initMjml';

import App from './App';
import render from './render';
import './wdyr';

// HMR typing for webpack
declare const module: {
  hot?: { accept: (dep: string, cb: () => void) => void };
};

// Ensure a baseline performance start mark exists before any components measure
if (
  typeof performance !== 'undefined' &&
  typeof performance.mark === 'function'
) {
  performance.mark('app-start');
}

render(App);

if ((module as any).hot) {
  (module as any).hot.accept('./App', () => {
    const NextApp = require('./App').default;

    render(NextApp);
  });
}
